import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './locales/tr.json';
import ru from './locales/ru.json';
import { STORAGE_KEYS } from '../constants';

const SUPPORTED_LANGUAGES = ['tr', 'ru'];
const DEFAULT_LANGUAGE = 'tr';
const FALLBACK_LANGUAGE = 'tr';

const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.LANGUAGE);
    if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
      return stored;
    }
  } catch {
    // localStorage erişilemezse varsayılan dile dön
  }
  return DEFAULT_LANGUAGE;
};

const updateDocumentLanguage = (language) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language;
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      ru: { translation: ru }
    },
    lng: getStoredLanguage(),
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false
    },
    returnEmptyString: false
  });

updateDocumentLanguage(i18n.language);

i18n.on('languageChanged', (language) => {
  try {
    localStorage.setItem(STORAGE_KEYS.LANGUAGE, language);
  } catch {
    // localStorage yazılamazsa sessizce devam et
  }
  updateDocumentLanguage(language);
});

export { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, FALLBACK_LANGUAGE };
export default i18n;
